// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"21dc2c52","77":"7a09f1a8","173":"b499254b","929":"290f6d85"}[chunkId] + ".chunk.js";
};